import { useEffect } from 'react';
import { pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { useIsAdmin } from 'js/hooks/user';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import * as actions from 'js/components/system/Page/store/actions';

import * as helpers from './helpers';

export const usePageAsPopupBackground = ({ isPageInPopup, path, page, pageError }) => {
    const isAdmin = useIsAdmin();
    const dispatch = useDispatch();
    const { lang, role } = useUserSelector(pick(['lang', 'role']));
    const { rootPage, defaultLocale, dynamicRoutingUrls } = useAppSelector(pick(['rootPage', 'defaultLocale', 'dynamicRoutingUrls']));

    useEffect(() => {
        if (isPageInPopup) {
            return;
        }

        if (pageError && pageError.path === path) {
            dispatch(actions.setPopupBackgroundPagePath(rootPage || '/'));
        }

        if (page && (page.url[lang] || page.path === path)) {
            const configuredUrl = page.dynamicPagePath || page.url[lang] || page.url[defaultLocale];
            const pageDynamicId = helpers.getPageDynamicId(page.path, dynamicRoutingUrls);
            const backgroundPagePath = configuredUrl
                ? `${configuredUrl}${pageDynamicId ? `/${pageDynamicId}` : ''}`
                : path;

            dispatch(actions.setPopupBackgroundPagePath(isAdmin || page?.permissions[role] ? backgroundPagePath : rootPage));
        }
    }, [
        dispatch, rootPage, isPageInPopup, page, pageError, lang,
        path, defaultLocale, dynamicRoutingUrls, isAdmin, role
    ]);
};
